import { useEffect, useState } from "react";

const DEFAULT_BREAKPOINT = 768;

function useMatchMedia(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function useIsMobile(breakpoint = DEFAULT_BREAKPOINT) {
  return useMatchMedia(`(max-width: ${breakpoint}px)`);
}

/** True on phones/tablets where a virtual keyboard would cover the option cards. */
export function useCoarsePointer() {
  return useMatchMedia("(pointer: coarse)");
}

export default useIsMobile;
